import React, { useEffect } from 'react'
import { connect } from 'dva'
import styles from './Center.module.less'

const user = [
  {
    key: 'nickname',
    label: '昵称',
  },
  {
    key: 'teamName',
    label: '团队',
  },
  {
    key: 'annualRank',
    label: '年排名',
  },
]
const info = [
  {
    image: 'coin',
    key: 'goldBalance',
    keyTotal: 'goldTotal',
    label: '未兑换贡献币：',
  },
  {
    image: 'bug',
    key: 'bugValid',
    keyTotal: 'bugTotal',
    label: '有效漏洞/总漏洞：',
  },
  {
    image: 'contribution',
    key: 'score',
    label: '贡献值：',
  },
  {
    image: 'level',
    key: 'level',
    label: '成长等级：',
  },
]
const Center = ({ dispatch, userInfo }) => {
  useEffect(() => {
    dispatch({
      type: 'center/getPersonalProfile',
    })
  }, [dispatch])

  return (
    <div styleName="container">
      <div style={{ marginBottom: '100px' }} styleName="dis-flex">
        <img src={userInfo.avatar} styleName="container__avatar" />
        <div styleName="flex-1">
          {user.map((it) => (
            <div key={it.key} styleName="container__user">
              {it.label}：{userInfo[it.key] || '无'}
            </div>
          ))}
        </div>
      </div>
      <div styleName="dis-flex">
        <div style={{ marginRight: '23px' }} styleName="flex-1">
          {info.slice(0, 2).map((it) => (
            <div
              key={it.key}
              className={`${styles.container__info} ${styles[it.image]}`}
            >
              <div styleName="container__info--key">{it.label}</div>
              {it.image === 'coin' ? (
                <div styleName="container__info--value">{userInfo[it.key]}</div>
              ) : (
                <div styleName="container__info--value">
                  {userInfo[it.key]}
                  {userInfo[it.keyTotal] !== undefined && (
                    <span>
                      <span style={{ margin: '0 5px' }}>/</span>
                      {userInfo[it.keyTotal]}
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        <div styleName="flex-1">
          {info.slice(2).map((it) => (
            <div
              key={it.key}
              className={`${styles.container__info} ${styles[it.image]}`}
            >
              <div styleName="container__info--key">{it.label}</div>
              <div styleName="container__info--value">{userInfo[it.key]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default connect(({ center }) => {
  return {
    userInfo: center.userInfo,
  }
})(Center)
